// extracted by mini-css-extract-plugin
export default {"title":"TicketsToPost_title__rKelk","ticketsToPost":"TicketsToPost_ticketsToPost__6Pmk1","ticketsList":"TicketsToPost_ticketsList__QGgic","spinner":"TicketsToPost_spinner__rfZCi"};